import '../../../../../../../node_modules/glightbox/dist/css/glightbox.min.css'
import GLightbox from 'glightbox'
import './Styles.scss'

(() => {
	const galleries = document.querySelectorAll('[data-post-gallery]')
	if (!galleries.length) {
		return
	}

	const galleryIds = new Set()
	galleries.forEach((gallery) => {
		if (gallery.dataset.postGallery) {
			galleryIds.add(gallery.dataset.postGallery)
		}
	})

	galleryIds.forEach((galleryId) => {
		GLightbox({
			selector: `[data-post-gallery="${galleryId}"]`,
			loop: false
		})
	})
})()
